import { render, staticRenderFns } from "./FormulaLibraryReviewList.vue?vue&type=template&id=1176cad7"
import script from "./FormulaLibraryReviewList.vue?vue&type=script&lang=js"
export * from "./FormulaLibraryReviewList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports